import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Shared chrome for inbox comment post previews: the white card container plus
 * an optional "view original post" link footer. Each platform-specific preview
 * provides its own body as children.
 *
 * @component PostPreviewLayoutMC
 * @param {Object} props - Component properties
 * @param {React.ReactNode} props.children - The preview body.
 * @param {string} [props.originalPostUrl] - URL for the "view original post" link; the footer is hidden when absent.
 * @returns {JSX.Element} The rendered card wrapper.
 */
const PostPreviewLayoutMC = ({ children, originalPostUrl }) => {
  const { t } = useTranslation('InboxMC');

  return (
    <div className="tw-bg-white tw-p-4 tw-mb-4 tw-rounded-lg tw-shadow-sm tw-flex tw-flex-col tw-max-w-[550px]">
      {children}
      {originalPostUrl && (
        <div className="tw-mt-2">
          <a
            href={originalPostUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="tw-text-blue-500 tw-text-xs tw-hover:underline tw-font-semibold"
          >
            {t('chatWindow.view_original_post', 'Ver publicación original')}
          </a>
        </div>
      )}
    </div>
  );
};

export default PostPreviewLayoutMC;
